import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import MarketForm from './components/MarketForm/MarketForm';
import GraphBuilding from './components/GraphBuilding/GraphBuilding';
import GraphView from './components/GraphView/GraphView';
import { createMarket } from './utils/api';
import './styles/variables.css';
import './styles/global.css';
import './App.css';

function HomePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (question) => {
    setIsSubmitting(true);
    try {
      const response = await createMarket(question);
      const marketId = response.market.id;
      navigate(`/graphBuilding/${marketId}`);
    } catch (error) {
      console.error('Error creating market:', error);
      alert('Error: ' + error.message);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app">
      <header className="app__header">
        <div className="app__header-content">
          <img src="/logo.png" alt="Composer" className="app__logo" />
          <div className="app__header-text">
            <h1 className="app__title">Composer</h1>
            <p className="app__subtitle">Factor Graph Builder</p>
          </div>
        </div>
      </header>

      <main className="app__main">
        <MarketForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
      </main>

      <footer className="app__footer">
        <p className="app__footer-text">
          Markets for people who reason
        </p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/graphBuilding/:marketId" element={<GraphBuilding />} />
      <Route path="/graph/:marketId" element={<GraphView />} />
    </Routes>
  );
}

export default App;
